function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            //check safari
            if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
               $('body').addClass('isSafari')        
            }
            
            // Accordion
            
              function addExpandedClassOnMobile() {
                var screenWidth = $(window).width();
            
                if (screenWidth <= 768) { // Adjust the threshold as needed
                  $('.filter-group.has_group_selected').addClass('pt-group-expanded');
                } else {
                  $('.filter-group.has_group_selected').removeClass('pt-group-expanded');
                }
              }
              addExpandedClassOnMobile();
              
              // Add an event listener for window resize
              $(window).resize(function() {
                addExpandedClassOnMobile();
              });
            
              $('.filter-clear').each(function() {
                var clearButton = $(this);
                var scrollContent = clearButton.closest('.filter-group').find('.scroll-content');
                scrollContent.prepend(clearButton);
              });
            
              
              if ($('.filter-group').hasClass('pt-group-expanded')) {
                $('.filter-group.pt-group-expanded h4').attr('aria-expanded', 'true');
              } else {
                $('.filter-group').not('.refine-header, .pt-display-dropdown').find('h4').attr('aria-expanded', 'false');
              }
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                if($(this).find('li.selected').length) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return $(element).text();
                    }
                  ).join(", ");

                  if (selected.length < 30) {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + selected +'</div>');
                  } else {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + $(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                  $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                }
              }
            });

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested));
              })
            })
            
            // Ajax
            
            var ajaxmq = window.matchMedia("(min-width: 767px)")
            if (window.location.pathname.lastIndexOf('/collections/', 0) === 0 && ajaxmq.matches) {
              var pjax = new Pjax({
                elements: '#page-content .filter-group li a, .filter-group .filter-clear, #page-content .pagination a',
                selectors: ['title', '#page-content'],
                scrollTo:false,
                timeout: 10000
              });
            }
            
          }

          pt_on_load();

          // Add selected class before page load
          $(document).on('click', '.filter-menu .filter-group .collection-container a', function () {
            $(this).parent().toggleClass('selected');
            if ($(this).closest('.filter-group').hasClass('has_group_selected')) {
              $(this).closest('li').siblings().removeClass('selected');
            }
          });

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              if ($('.pt-nav-toggle').hasClass('active')) {
                $(this).find('p').text('Show Filters');
                $('.filter-menu').removeClass('pt-expand');
                $('.filter-menu-inner').removeClass('drawer-open');
                $('body').removeClass('no-scroll');
                $('.pt-overlay').remove();
                // $('.pt-display-dropdown .scroll-content').hide();
                $('.pt-nav-toggle').attr('aria-expanded', 'false');
                $('.pt-nav-toggle').attr('aria-label', 'Show Filters');
              } else {
                $(this).find('p').text('Hide Filters');
                $('.filter-menu').addClass('pt-expand');
                $('.filter-menu-inner').addClass('drawer-open');
                $('body').addClass('no-scroll');
                var overlay = $('<div class="pt-overlay"></div>');
                $('main').prepend(overlay);
                $('.pt-nav-toggle').attr('aria-expanded', 'true');
                $('.pt-nav-toggle').attr('aria-label', 'Hide Filters');

                $('.filter-menu .refine-header .close-mobile-drawer').remove();
                var closeButtonRefineHeader = $('<div class="close-mobile-drawer">&times;</div>');
                closeButtonRefineHeader.on('click', function() {
                    $('#pt-nav-toggle').click();
                });
                $('.pt-overlay').on('click', function() {
                    $('#pt-nav-toggle').click();
                });
                $('.filter-menu .refine-header').append(closeButtonRefineHeader);
              }

              $('.pt-nav-toggle').toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          
          $(document).on('click', '.filter-menu h4', function(e) {
            var currentAccordion = $(this).closest('.filter-group').not('.refine-header, .pt-display-dropdown');
            var scrollContent = currentAccordion.find('.scroll-content');
        
            // remove any existing close buttons
            scrollContent.find('.close-accordion').remove();
        
            if (!currentAccordion.hasClass('pt-group-expanded')) {
              // close all other accordions on desktop, keep selected open on mobile
              if ($(window).width() <= 768) {
                $('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').removeClass('pt-group-expanded');
              } else {
                $('.filter-group').not('.refine-header, .pt-display-dropdown').removeClass('pt-group-expanded');
              }
      
              // open the clicked accordion
              currentAccordion.addClass('pt-group-expanded');
              $('.filter-group h4').attr('aria-expanded', 'false');
              currentAccordion.find('h4').attr('aria-expanded', 'true');
      
              // check screen width before adding the close button
              if ($(window).width() > 768) {
                // create a close button and append it to the open accordion
                var closeButton = $('<button class="close-accordion">Done</button>');
                closeButton.on('click', function() {
                  currentAccordion.removeClass('pt-group-expanded');
                  currentAccordion.find('h4').attr('aria-expanded', 'false');
                  closeButton.remove(); // Remove the close button when closing the accordion
                });
                scrollContent.append(closeButton);
              }
          } else {
            // close the clicked accordion
            currentAccordion.removeClass('pt-group-expanded');
            currentAccordion.find('h4').attr('aria-expanded', 'false');
          }
      
          e.preventDefault();
        });

          
          $(document).on('keydown', '.filter-menu h4', function(e){
            if(e.which == 13 || e.which == 32) {
              e.preventDefault();
              $(this).click();
            }
          });
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger', function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).next('.scroll-content').toggleClass('dropdown-open')
            if ($(this).next('.scroll-content').hasClass('dropdown-open')) {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection expanded');
            } else {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
            }
          });
          
          $(document).on('keydown', '.pt-display-dropdown .menu-trigger', function(e) {
            if(e.which == 13 || e.which == 32 ) { // return or space keys
              e.preventDefault();
              $(this).click();
            }
          });
          
          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).removeClass('dropdown-open');
            $(this).slideUp('fast');
            $(this).prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });
          
          $(document).on('focusout', '.pt-display-dropdown .scroll-content li:last-child', function() {
            $(this).closest('.scroll-content').removeClass('dropdown-open');
            $(this).closest('.scroll-content').slideUp('fast');
            $(this).closest('.scroll-content').prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });

          // Apply button - edited for mobile only 
          
          var mq = window.matchMedia("(max-width: 767px)")
          if (mq.matches) {
            $(document).on('click', '.filter-menu .filter-group a, .filter-group a.filter-clear', function(e) {
              e.preventDefault();
              console.log(e.target)
              var current_url = $(this).attr('href');      
              $('.filter-group').addClass('pt-group-disabled');
              // load new filters
              $.get(current_url, function( data ) {
                var elem = $(data).find('.filter-menu-inner > div:first-of-type')[0] || $(data);
                $('.filter-menu-inner > div:first-of-type').replaceWith(elem).fadeTo('fast', 1.0);
                $('.pt-apply-form').attr('action', current_url);
                $('.pt-apply-form .pt-apply').removeClass('pt-apply-disabled');
                pt_on_load();
                 // open mobile accordion after matching filters loaded
                //$('.filter-menu .pt-mobile-header a').trigger('click');
                
              });
            });
          } 
          

          // Ajax
          
            var body = document.querySelector('body');
            document.addEventListener('pjax:send', function(){  
              body.classList.add("pt-ajax-loading"); 
            });
            document.addEventListener('pjax:complete', function(){ 
              body.classList.remove("pt-ajax-loading");
              pt_on_load();
              ;$('#site-control').removeClass('nav-fade-out');theme.initAnimateOnScroll(); 
            });
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
